<template>
  <a-spin
    :spinning="isLoading"
    class="custom-spinner"
    style="height: 100vh; top: 20%"
  >
    <TableView
      v-if="requests.items && 0 < requests.items.length"
      :head="{
        rows: [
          {
            cells: [
              { content: 'Дата' },
              { content: 'ФИО' },
              { content: 'Контакты' },
              { content: 'Проект' },
            ],
          },
        ],
      }"
      :body="convertToTable(requests.items)"
      :pages="requests.pages"
    />

    <p v-else>Запросы не найдены.</p>
  </a-spin>
  <c-drawer
    v-if="isEditable"
    v-model:open="isOpenModal"
    width="420"
    destroyOnClose
  >
    <component
      :is="JoinToTeamForm"
      :request="currentRequest"
      @close="isOpenModal = false"
      @change-request="loadRequests()"
    />
  </c-drawer>
</template>

<script setup>
  import TableView from '@/components/table/TableView.vue';
  import { useApi } from '@/api/use-api';
  import { ref, watch } from 'vue';
  import { STATUS_NEW } from '@/constants/project-team-request';
  import CDrawer from '@/components/UI/CDrawer.vue';
  import JoinToTeamForm from '@/views/leader/team/forms/JoinToTeamForm.vue';
  import DoubleDataCell from '@/components/table/DoubleDataCell.vue';
  import { ApiDateAdapter } from '@/adapters/api-date';
  import { ApiDateTimeAdapter } from '@/adapters/api-date-time';
  import { ApiTimeAdapter } from '@/adapters/api-time';

  const props = defineProps({
    isEditable: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Number,
      default: STATUS_NEW,
    },
  });

  const isOpenModal = ref(false);
  const currentRequest = ref(null);
  const isLoading = ref(false);
  const requests = ref([]);
  const api = useApi();
  const emit = defineEmits(['update']);

  const loadRequests = async () => {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;

    try {
      const params = new URLSearchParams();
      params.set('status', props.status.toString());

      const response = await api.projectTeamRequest.all(params);
      emit('update');
      requests.value = response.projectTeamRequests;
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  const convertToTable = (requests) => {
    return {
      rows: requests.map((request) => ({
        cells: [
          {
            content: {
              is: DoubleDataCell,
              bind: {
                up: ApiDateAdapter.toRussian(
                  ApiDateTimeAdapter.toDate(request.createdAt)
                ),
                down: ApiTimeAdapter.toHoursMinutes(
                  ApiDateTimeAdapter.toTime(request.createdAt)
                ),
              },
            },
          },
          {
            content: `${request.lastName} ${request.firstName} ${request.middleName}`,
          },
          {
            content: {
              is: DoubleDataCell,
              bind: {
                up: request.email,
                down: request.phone,
              },
            },
          },
          { content: request.project.name },
        ],
        on: {
          click: () => {
            currentRequest.value = request;
            isOpenModal.value = true;
          },
        },
      })),
    };
  };

  watch(
    () => props.status,
    async () => {
      await loadRequests();
    },
    { immediate: true }
  );
</script>

<style lang="scss" scoped></style>
